import { SUPPORTED_LOCALES } from '../i18n/config';
import { RS_FEATURED_PUBLIC_BOARD_URL } from './reservationFeaturedBoard.config';
import { gaisukePublicPath } from '../utils/gaisukePath';
import { keibaArenaPublicPath } from '../utils/keibaArenaPath';
import { banquetPublicPath } from '../utils/banquetPath';
import { econReportPublicPath } from '../utils/econReportPath';
import { keisukePublicPath } from '../utils/keisukePath';

export const SITE_URL = 'https://kensuke-system.com';
export const SITE_NAME = 'kensuke-system';
export const SITE_ALTERNATE_NAMES = ['Kensuke', '研助', 'けんすけ'] as const;

/** sitemap.xml の lastmod（公開インデックス更新日） */
export const SITEMAP_LASTMOD = '2026-08-30';

export const LLMS_TXT_URL = `${SITE_URL}/llms.txt`;
export const LLMS_FULL_TXT_URL = `${SITE_URL}/llms-full.txt`;
export const SITEMAP_URL = `${SITE_URL}/sitemap.xml`;
export const VIDEO_SITEMAP_URL = `${SITE_URL}/sitemap-video.xml`;

/** ログイン不要でクロール・引用しやすい公開 URL */
export const PUBLIC_CRAWL_URLS = {
  home: SITE_URL,
  help: `${SITE_URL}/help`,
  gaisuke: `${SITE_URL}/gaisuke`,
  keibaArena: `${SITE_URL}/arena/keiba`,
  banquet: `${SITE_URL}/arena/banquet`,
  econReport: `${SITE_URL}/arena/econ`,
  gaisukeFx: `${SITE_URL}/arena/fx`,
  laboSuke: `${SITE_URL}/labo-suke`,
  keisuke: `${SITE_URL}/keisuke`,
  transitPass: `${SITE_URL}/transit-pass-pool`,
  geneAnalysis: `${SITE_URL}/gene-analysis`,
  reservationDemo: RS_FEATURED_PUBLIC_BOARD_URL,
  login: `${SITE_URL}/login`,
  register: `${SITE_URL}/register`,
  privacy: `${SITE_URL}/privacy`,
  terms: `${SITE_URL}/terms`,
} as const;

/** ホーム・help・contact で無印 URL が正規となるロケール（`/`・`/help` 等） */
export const BARE_PUBLIC_LOCALE = 'ja' as const;

export function isBarePublicLocale(locale: string): boolean {
  return locale === BARE_PUBLIC_LOCALE || locale.startsWith(`${BARE_PUBLIC_LOCALE}-`);
}

/** ホームのパス（ja → `/`、他 → `/{locale}`） */
export function localeHomePath(locale: string): string {
  if (isBarePublicLocale(locale)) return '/';
  if (SUPPORTED_LOCALES.includes(locale as (typeof SUPPORTED_LOCALES)[number])) {
    return `/${locale}`;
  }
  const short = locale.split('-')[0];
  if (SUPPORTED_LOCALES.includes(short as (typeof SUPPORTED_LOCALES)[number])) {
    return `/${short}`;
  }
  return '/';
}

export function localeHomeUrl(locale: string): string {
  const path = localeHomePath(locale);
  return path === '/' ? `${SITE_URL}/` : `${SITE_URL}${path}`;
}

/**
 * help / contact 等の公開パス（ja → `/help`、他 → `/en/help`）。
 * Gaisuke の ja 無印と同じ方針。
 */
export function localePublicPagePath(locale: string, page: string): string {
  const clean = page.replace(/^\/+|\/+$/g, '');
  if (!clean) return localeHomePath(locale);
  if (isBarePublicLocale(locale)) return `/${clean}`;
  if (SUPPORTED_LOCALES.includes(locale as (typeof SUPPORTED_LOCALES)[number])) {
    return `/${locale}/${clean}`;
  }
  const short = locale.split('-')[0];
  if (SUPPORTED_LOCALES.includes(short as (typeof SUPPORTED_LOCALES)[number])) {
    return `/${short}/${clean}`;
  }
  return `/${clean}`;
}

export function localeGaisukeUrl(locale: string): string {
  return `${SITE_URL}${gaisukePublicPath(locale)}`;
}

export function localeKeibaArenaUrl(locale: string): string {
  return `${SITE_URL}${keibaArenaPublicPath(locale)}`;
}

export function localeBanquetUrl(locale: string): string {
  return `${SITE_URL}${banquetPublicPath(locale)}`;
}

export function localeEconReportUrl(locale: string): string {
  return `${SITE_URL}${econReportPublicPath(locale)}`;
}

export function localeKeisukeUrl(locale: string): string {
  return `${SITE_URL}${keisukePublicPath(locale)}`;
}

export function localeHelpUrl(locale: string): string {
  return `${SITE_URL}${localePublicPagePath(locale, 'help')}`;
}
